<div class="layout-topbar">
    <a class="layout-topbar-logo" routerLink="">
        <img src="assets/imagens/lxtech-logo.png" alt="logo">
        <span class="font-bold">LXVIEW</span>
    </a>

    <button #menubutton class="p-link layout-menu-button layout-topbar-button" (click)="layoutService.onMenuToggle()">
        <i class="pi pi-bars"></i>
    </button>

    <button #topbarmenubutton class="p-link layout-topbar-menu-button layout-topbar-button" (click)="layoutService.showProfileSidebar()">
        <i class="pi pi-ellipsis-v"></i>
    </button>

    <div #topbarmenu class="layout-topbar-menu" [ngClass]="{'layout-topbar-menu-mobile-active': layoutService.state.profileSidebarVisible}">
        <p-dropdown inputId="dpAmbiente" emptyMessage="Nenhum ambiente configurado" [options]="ambientes" (onChange)="trocarAmbiente()" optionLabel="ambiente" [(ngModel)]="ambienteSelecionado" [style]="{'min-width': '15rem'}" placeholder="Selecione um ambiente"></p-dropdown>
        <span class="p-link layout-topbar-button ml-2 mr-2" style="min-width: 10rem">Olá, {{ nomeUsuario }}</span>
        <button class="p-link layout-topbar-button" (click)="menu.toggle($event)">
            <i class="pi pi-user"></i>
            <span>Perfil</span>
        </button>
        <p-menu #menu [model]="items" [popup]="true"></p-menu>
        <!-- <button class="p-link layout-topbar-button" [routerLink]="'/documentation'">
            <i class="pi pi-cog"></i>
            <span>Coonfigurações</span>
        </button> -->
    </div>
</div>